import { useAnalytics } from '~/composables/useAnalytics';

interface AnalyticsPluginInjection {
  $analytics: ReturnType<typeof useAnalytics>;
}

declare module '#app' {
  // @ts-expect-error NuxtApp recursive issue
  interface NuxtApp extends AnalyticsPluginInjection { }
}

declare module 'vue' {
  interface ComponentCustomProperties extends AnalyticsPluginInjection { }
}

export { };

export default defineNuxtPlugin({
  name: 'analytics',
  setup() {
    const analytics = useAnalytics();

    return {
      provide: {
        analytics,
      },
    };
  },
});
